import { PosModel } from '@/types'

export const demoRegister: PosModel.Register = {
  _id: 'reg-01',
  name: 'Counter 1',
  cashier: 'Mitu Rahman',
  opened_at: new Date(new Date().setHours(9, 0, 0, 0)).toISOString(),
  opening_float: 5000,
  tax_rate: 0.05,
  currency: 'BDT',
}
